<template>
  <v-card-text>
    <v-select
        v-model="type"
        hint="Wybierz typ magazynu"
        :items="types"
        item-text="name"
        item-value="id"
        label="Typ magazynu"
        persistent-hint
        return-object
        single-line
    ></v-select>
  </v-card-text>
</template>
<script>
import options from "@/mixins/options"

export default {
  name: "storage-options",
  mixins: [ options ],
  computed:{
    types(){
       if(this.$store.state.storageTypes === null){
         this.$store.dispatch('loadStorageTypes')
       }
       return this.$store.state.storageTypes
    }
  },
  data(){
    return{
      type: null
    }
  },
  created() {
    this.type = this.options.storage_type_id
  },
  watch: {
    type: function (val) {
      this.update({
        storage_type_id: typeof val === 'object' && val.id ? val.id : val
      })
    }
  }
}
</script>
<style>
</style>
